module.exports = __webpack_public_path__ + "img/head-brain-icon.9b8d046a.svg";